export default {
  login: {
    succeed: "login_succeed",
    failed: "login_failed",
    usernameRequired: "username_required",
    passwordRequired: "password_required",
    systemFailed: "system_error"
  },
  logout: {
    succeed: "logout_succeed",
    failed: "logout_failed"
  },
  firstTime: {
    failed: "login_failed",
    newUsernameRequired: "new_username_required",
    newPasswordRequired: "new_password_required"
  },
  security: {
    failed: "security_failed",
    securityCodeRequired: "security_code_required"
  },
  request: {
    succeed: "request_succeed",
    failed: "request_failed",
    processing: "request_processing"
  },
  session: {
    invalidToken: "invalid_token",
    expired: "session_expired",
    invalidSession: "invalid_session"
  },
  updatePassword: {
    succeed: "update_password_succeed",
    failed: "update_password_failed",
    passwordRequired: "password_required",
    newPasswordRequired: "new_password_required"
  },
  getGameTypeLookup: {
    succeed: "get_game_lookup_succeed",
    failed: "get_game_lookup_failed"
  },
  getLeagueLookup: {
    succeed: "get_league_lookup_succeed",
    failed: "get_league_lookup_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required"
  },
  getMatchResult: {
    succeed: "get_match_result_succeed",
    failed: "get_match_result_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required",
    leagueIDRequired: "league_id_required"
  },
  unblockProfile: {
    succeed: "unblock_profile_succeed",
    failed: "unblock_profile_failed",
    profileIDRequired: "profile_id_required"
  },
  resetPassword: {
    succeed: "reset_password_succeed",
    failed: "reset_password_failed",
    accountIDRequired: "account_id_required",
    newPasswordRequired: "new_password_required"
  },
  getAccountList: {
    succeed: "get_account_list_succeed",
    failed: "get_account_list_failed",
    accountIDRequired: "account_id_required"
  },
  getMemberList: {
    succeed: "get_member_list_succeed",
    failed: "get_member_list_failed",
    accountIDRequired: "account_id_required"
  },
  updateStatus: {
    succeed: "update_status_succeed",
    failed: "update_status_failed",
    accountIDRequired: "account_id_required",
    statusRequired: "status_required"
  },
  getAccountDetails: {
    succeed: "get_account_details_succeed",
    failed: "get_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  addAccount: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed",
    loginIDRequired: "login_id_required",
    passwordRequired: "password_required",
    targetAccountIdContainReservedWord: "targetAccountIdContainReservedWord"
  },
  updateAuthority: {
    succeed: "update_authority_succeed",
    failed: "update_authority_failed",
    authorityOptionRequired: "authorityOptionRequired"
  },
  subAccountBlock: {
    succeed: "block_sub_account_succeed",
    failed: "block_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  subAccountUnblock: {
    succeed: "unblock_sub_account_succeed",
    failed: "unblock_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  getSettlementHistory: {
    succeed: "get_settlement_history_succeed",
    failed: "get_settlement_history_failed",
    accountIDRequired: "account_id_required"
  },
  getBetlist: {
    succeed: "get_betlist_succeed",
    failed: "get_betlist_failed",
    accountIDRequired: "account_id_required",
    betTypeRequired: "bet_type_required",
    searchIDRequired: "search_id_required",
    matchIDRequired: "match_id_required",
    isLiveRequired: "is_live_required",
    homeRunningScoreRequired: "home_running_score_required",
    awayRunningScoreRequired: "away_running_score_required"
  },
  getParlayDetail: {
    succeed: "get_parlay_detail_succeed",
    failed: "get_parlay_detail_failed",
    betIDRequired: "bet_id_required"
  },
  getBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  getHdpPackage: {
    succeed: "get_hdp_pk_succeed",
    failed: "get_hdp_pk_failed",
    accountIDRequired: "account_id_required"
  },
  getDefaultBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  updateOperatorBetLimit: {
    succeed: "update_bet_limit_succeed",
    failed: "update_bet_limit_failed",
    accountIDRequired: "account_id_required"
  },
  getCommission: {
    succeed: "get_cm_succeed",
    failed: "get_cm_failed",
    accountIDRequired: "account_id_required"
  },
  getPositionTaking: {
    succeed: "get_pt_succeed",
    failed: "get_pt_failed",
    accountIDRequired: "account_id_required"
  },
  checkDownline: {
    succeed: "check_downline_succeed",
    failed: "check_downline_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyStatement: {
    succeed: "get_daily_statement_succeed",
    failed: "get_daily_statement_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyWinlose: {
    succeed: "get_daily_winlose_succeed",
    failed: "get_daily_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getPlatform: {
    succeed: "get_platform_succeed",
    failed: "get_platform_failed",
    accountIDRequired: "account_id_required"
  },
  getGameResult: {
    succeed: "get_game_result_succeed",
    failed: "get_game_result_failed",
    accountIDRequired: "account_id_required",
    memberIDRequired: "member_id_required"
  },
  getPendingMatches: {
    succeed: "get_pending_matches_succeed",
    failed: "get_pending_matches_failed",
    accountIDRequired: "account_id_required"
  },
  getKeyList: {
    succeed: "get_key_list_succeed",
    failed: "get_key_list_failed"
  },
  addKey: {
    succeed: "insert_key_succeed",
    failed: "insert_key_failed"
  },
  updateKey: {
    succeed: "update_key_succeed",
    failed: "update_key_failed"
  },
  getIpList: {
    succeed: "get_ip_list_succeed",
    failed: "get_ip_list_failed"
  },
  updateIp: {
    succeed: "update_ip_succeed",
    failed: "update_ip_failed"
  },
  updatePositionTakingSB1: {
    succeed: "update_position_taking_sb1_succeed",
    failed: "update_position_taking_sb1_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionSB: {
    succeed: "update_commission_sb_succeed",
    failed: "update_commission_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitSB: {
    succeed: "update_bet_limit_sb_succeed",
    failed: "update_bet_limit_sb_failed",
    accountIDRequired: "account_id_required"
  },
  cashDeposit: {
    succeed: "cash_deposit_succeed",
    failed: "cash_deposit_failed",
    accountIDRequired: "account_id_required"
  },
  cashWithdrawal: {
    succeed: "cash_withdrawal_succeed",
    failed: "cash_withdrawal_failed",
    accountIDRequired: "account_id_required"
  },
  getDashboardInfo: {
    succeed: "get_dashboard_info_succeed",
    failed: "get_dashboard_info_failed",
    accountIDRequired: "account_id_required"
  },
  getSportTypeWinlose: {
    succeed: "get_sport_type_winlose_succeed",
    failed: "get_sport_type_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getLeagueWinlose: {
    succeed: "get_league_winlose_succeed",
    failed: "get_league_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required"
  },
  getMatchWinlose: {
    succeed: "get_match_winlose_succeed",
    failed: "get_match_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required"
  },
  getMatchMemberWinlose: {
    succeed: "get_match_member_winlose_succeed",
    failed: "get_match_member_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required",
    matchIDRequired: "match_id_required"
  },
  updatePositionTakingMMO: {
    succeed: "update_position_taking_mmo_succeed",
    failed: "update_position_taking_mmo_failed",
    accountIDRequired: "account_id_required"
  },
  getLog: {
    urlRequired: "url_required",
    targetIDRequired: "target_id_required"
  },
  message: {
    succeed: "getMessageSucceed",
    failed: "getMessageFailed",
    startDateRequired: "startDateRequired",
    endDateRequired: "endDateRequired",
    anTypeRequired: "anTypeRequired"
  },
  getSystemParlay: {
    succeed: "get_system_parlay_succeed",
    failed: "get_system_parlay_failed",
    accountIDRequired: "account_id_required"
  },
  getMatchLookup: {
    succeed: "get_match_lookup_succeed",
    failed: "get_match_lookup_failed",
    leagueIDRequired: "league_id_required",
    pageSizeRequired: "page_size_required",
    pageNumberRequired: "page_number_required"
  },
  getTournamentRoomMatchList: {
    succeed: "get_tournament_room_match_list_succeed",
    failed: "get_tournament_room_match_list_failed",
    roomIDRequired: "room_id_required",
    pageSizeRequired: "page_size_required",
    pageNumberRequired: "page_number_required"
  },
  getTournamentRommList: {
    succeed: "get_tournament_room_list_succeed",
    failed: "get_tournament_room_list_failed",
    systemIDRequired: "system_id_required",
    pageSizeRequired: "page_size_required",
    pageNumberRequired: "page_number_required"
  },
  createTournamentPublicRoom: {
    succeed: "create_tournament_public_room_succeed",
    failed: "create_tournament_public_room_failed",
    roomRateRequired: "room_rate_required",
    roomLimitRequired: "room_limit_required",
    matchRequired: "match_required",
    roomTypeRequired: "room_type_required"
  },
  getPlatformWinlose: {
    succeed: "get_platform_winlose_succeed",
    failed: "get_platform_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  otp: {
    failed: "otp_verification_failed",
    codeRequired: "code_required",
    invalidCode: "invalid_code",
    setupFailed: "otp_setup_failed",
    verificationFailed: "otp_verification_failed"
  }
};
